<template>
  <div class="ls-input-ft--input-container">
    <LsInputLabel v-if="label" :label="label" />
    <div class="ls-input-ft--input">
      <BField :type="{ 'is-error': getValidation.invalid }">
        <BInput
          v-model="localValue"
          v-validate="getValidationRule"
          test-id="ls-input"
          :disabled="disabled || loading"
          :name="name"
          :loading="loading"
          :readonly="readonly"
          type="tel"
          maxlength="50"
          :has-counter="false"
          @blur="onBlur"
          @input.native="onInput"
        ></BInput>
      </BField>
      <span :class="getFtStyle"></span>
      <p class="ls-input-ft--error-validation">
        {{ getValidation.invalid ? 'Whole number required' : '' }}
      </p>
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import {
  lsPropTypeHelpers,
  lsTrackingService,
  lsValidationService,
  lsValidations,
} from 'ls-vue-common';
import Cleave from 'cleave.js';
import _ from 'lodash';
import LsInputLabel from '../LsInputLabel/LsInputLabel.vue';

export default {
  name: 'LsInputFt',
  inject: ['$validator'],
  components: {
    LsInputLabel,
  },
  props: {
    value: VueTypes.string.isRequired,
    trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
    name: VueTypes.string.isRequired,
    label: VueTypes.string,
    placeholder: VueTypes.string,
    disabled: VueTypes.bool.def(false),
    validation: VueTypes.object.def(_.constant(null)),
    loading: VueTypes.bool.def(false),
    readonly: VueTypes.bool.def(false),
  },
  data() {
    return {
      cleave: null,
      localValue: this.value,
    };
  },
  computed: {
    getValidationRule() {
      return lsValidations.ft;
    },
    getFtStyle() {
      return this.getValidation.invalid ? 'ls-input-ft--invalid-ft' : 'ls-input-ft--valid-ft';
    },
    getMask() {
      return {
        numeral: true,
        numeralPositiveOnly: true,
        numeralIntegerScale: 3,
        numeralDecimalScale: 0,
        stripLeadingZeroes: true,
      };
    },
    getValidation() {
      return lsValidationService.getValidation.call(this);
    },
  },
  mounted() {
    const el = this.$el.querySelector('input');
    this.cleave = new Cleave(el, this.getMask);
    this.cleave.setRawValue(this.value);
    this.localValue = this.cleave.getFormattedValue();
  },
  beforeDestroy() {
    this.cleave.destroy();
    this.cleave = null;
  },
  methods: {
    onBlur() {
      lsTrackingService.track({
        event: 'blur',
        target: this.trackId,
      });

      this.$emit('blur', this.cleave.getRawValue());
    },

    onInput() {
      // setTimeout fixes weird issue on Android where user can enter in one extra character
      setTimeout(() => {
        this.localValue = this.cleave.getFormattedValue();
        this.$emit('input', this.cleave.getRawValue());
      });
    },
  },
};
</script>

<style lang="scss">
.ls-input-ft--input-container {
  position: relative;
}

.ls-input-ft--valid-ft::after {
  content: 'ft';
  color: $white;
  background-color: $primary;
  padding: 4px 10px;
  right: 0;
  top: 39px;
  font-size: 1.2em;
  font-weight: bold;
  position: absolute;
}

.ls-input-ft--invalid-ft::after {
  content: 'ft';
  color: $white;
  background-color: $danger;
  padding: 4px 10px;
  right: 0;
  top: 39px;
  font-size: 1.2em;
  font-weight: bold;
  position: absolute;
}

.ls-input-ft--error-validation {
  color: $danger;
  font-size: 1rem;
  font-weight: bold;
  height: 15px;
}

.ls-input-ft--input > .field:not(:last-child) {
  margin-bottom: 0;
}

.themed-app {
  .ls-input-ft--valid-ft::after {
    color: $theme-color-white;
    background-color: $theme-color-primary;
  }

  .ls-input-ft--invalid-ft::after {
    color: $theme-color-white;
    background-color: $theme-color-danger;
  }

  .ls-input-ft--error-validation {
    color: $theme-color-danger;
  }
}
</style>
